<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
     <div class="d-flex justify-content-between">
       <div class="text-right m-4">
         <h5 style="font-size: 1vw !important"> تعیین ماموریت</h5>
       </div>
       <div class="d-flex" v-if="allItems.length">
         <a :href="`${this.download_url}/Determining_Mission/all/word/by/id/${id_user}`"  style="margin-top: 1.3vw;" class="btn btn-primary btn-submit-1">خروجی Word</a>
         <a :href="`${this.download_url}/Determining_Mission/all/pdf/by/id/${id_user}`"  style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی PDF</a>
         <a    style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; " class="btn btn-primary btn-submit-1 "
         :style="!status_show ? 'background-color: red; border-color: red' : 'background-color: green; border-color: green'"
                @click="acceptComplete"
         >
           <div v-if="!status_loading">

             <span v-if="!status_show">  تایید وضعیت</span>
             <span v-else>عدم تایید</span>
           </div>
           <div v-else>
             <div class="loader-line"></div>

           </div>
         </a>
       </div>

     </div>

      <div class="d-flex flex-column p-4" v-if="this.show_insert">
        <div class="d-flex flex-nowrap" >
          <div style="width: 10vw;" class="d-flex flex-column">
            <label>محور ماموریت</label>
            <textarea v-model="axis" name="" class="form-control" id="" cols="30" rows="30"></textarea>

          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label>عنوان سند بالادستی </label>
            <textarea v-model="title" name="" class="form-control" id="" cols="30" rows="30"></textarea>
          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label> محدوده ISIC (اختیاری) </label>
            <input type="text" class="form-control" v-model="range">

          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label>مدل نقش آفرینی</label>
            <select v-model="model" name="" id="" class="form-select">
              <option value="سیاست‌گذاری">سیاست‌گذاری</option>
              <option value="تنظیم‌گری ">تنظیم‌گری</option>
              <option value="خدمات عمومی   "> خدمات عمومی</option>
              <option value="کنترل حاکمیتی   ">کنترل حاکمیتی</option>
              <option value=" تأمین مالی "> تأمین مالی</option>
            </select>
          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label>خروجی </label>
            <vSelect
                v-model="selectExit"
                :options="ListExits"
                dir="rtl"
                label="title"
                allow-clear="true"

            >
              <template v-slot:no-options>موردی یافت نشد</template>
            </vSelect>
          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label>پیامد </label>
            <button @click="allListConsequencesModal=true" class="btn " style="border: 1px solid #777; height: 2vw; display: grid; place-content: center">انتخاب کنید</button>

          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label>نماگر </label>
            <button @click="allNamaListConsequencesModalMethod" class="btn " style="border: 1px solid #777; height: 2vw; display: grid; place-content: center">انتخاب کنید</button>
          </div>
        </div>

        <div class="d-flex flex-nowrap">


          <div style="width: 10vw;" class="d-flex flex-column">
            <label>کلان خدمت </label>
            <vSelect
                v-model="selectProcess"
                :options="ListProcess"
                dir="rtl"
                label="title"
            >
              <template v-slot:no-options>موردی یافت نشد</template>
            </vSelect>
          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label>زیر خدمت </label>
            <vSelect
                v-model="selectParent"
                :options="ListParents"
                label="title"
                dir="rtl"
            >
              <template v-slot:no-options>موردی یافت نشد</template>
            </vSelect>
          </div>
          <button v-if="!is_update" @click.prevent="store" style="margin-top: 1.3vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">ذخیره</button>
        <div class="d-flex" v-else>
          <button  @click.prevent="update(id_item)" style="margin-top: 1.3vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">ویرایش</button>
          <Reset @click.prevent="resetItems" style="width: 1.5vw; height: 1.5vw; transform: translateY(1.3vw); cursor: pointer; margin-right: 1vw;" />
        </div>
        </div>
        <br>
        <hr>
      </div>


      <div class="table-responsive p-5">
        <center v-show="!allItems.length">
          ماموریت وجود ندارد
        </center>
        <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

        <table class="table table-striped" v-show="allItems.length">
          <tbody>
          <tr>
            <th rowspan="2"><strong>ردیف</strong></th>
            <th rowspan="2"><strong>
              محور مأموریتی
            </strong></th>

            <th rowspan="2"><strong>عنوان سند بالادستی </strong></th>
            <th rowspan="2"><strong> محدوده ISIC
              (اختیاری)
            </strong></th>
            <th rowspan="2"><strong>مدل نقش آفرینی</strong></th>
            <th colspan="3"><strong> زنجیره نتایج خدمت </strong></th>

            <th colspan="2"><strong>

              خدمت متناظر</strong></th>
            <th v-if="show_insert">عملیات</th>
          </tr>
          <tr>
            <th>خروجی</th>

            <th>پیامد</th>
            <th>نماگر</th>
            <th>کلان خدمت</th>
            <th> زیرخدمت (اختیاری)</th>
            <th v-if="show_insert">  </th>


          </tr>
          <tr v-for="(item, index) in allItems">
            <td>{{index+1}}</td>
            <td>{{item.axis}}</td>
            <td>{{item.title}}</td>
            <td>{{item.range}}</td>
            <td>{{item.model}}</td>
            <td>{{item.definition_of_outputs.title}}</td>
            <td >
              <span style="cursor: pointer; color: blue !important" @click="showItems(item.id)" >مشاهده</span>
            </td>
            <td >
              <span style="cursor: pointer; color: blue !important" @click="showItemsNama(item.id)" >مشاهده</span>
            </td>
            <td>{{item.processes && item.processes.title}}</td>
            <td>{{item.sub_processes && item.sub_processes.title ? item.sub_processes.title : '--'}}</td>
            <td v-if="show_insert">
              <a @click.prevent="editMethod(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
              <a @click.prevent="deleteMethod(item.id)" style="margin-right: 1vw;" href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
            </td>
          </tr>


          </tbody>
        </table>
      </div>
      </div>

    </div>
  </div>
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="allListConsequencesModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>پیامد ها    </p>
      <p @click="allListConsequencesModal=!allListConsequencesModal">❌</p>
    </div>
    <table class="table table-striped">
      <thead>
      <tr>
        <th style="width: 1vw !important;">انتخاب</th>
        <th>پیامد  </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in ListConsequences" :key="item.id">
        <td style="width: 1vw;" scope="row"><input v-model="ListConsequencesSelected"  type="checkbox"  :value="item['id']"></td>
        <td>{{ item['title'] }}</td>
      </tr>

      </tbody>
    </table>
   <center>
     <button class="btn-submit-1 btn-primary" @click="submitListConsequencesSelected">تایید</button>
   </center>
  </div>
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="allNamaListConsequencesModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>نماگر      </p>
      <p @click="allNamaListConsequencesModal=!allNamaListConsequencesModal">❌</p>
    </div>
    <table class="table table-striped">
      <thead>
      <tr>
        <th style="width: 1vw !important;">انتخاب</th>
        <th>نماگر  </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in otherItems" :key="item.id">
        <td style="width: 1vw;" scope="row"><input v-model="ListConsequencesNAMASelected" type="checkbox"   :value="item['id']"></td>
        <td>{{ item.measurement_chart }}</td>
      </tr>

      </tbody>
    </table>
   <center>
     <button class="btn-submit-1 btn-primary" @click="submitListConsequencesNamaSelected">تایید</button>
   </center>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allItemsModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>پیامد ها    </p>
      <p @click="allItemsModal=!allItemsModal">❌</p>
    </div>
    <table v-if="allItemsList.length" class="table table-striped">
      <thead>
      <tr>
         <th>ردیف  </th>
         <th>پیامد  </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in allItemsList" :key="item.id">
        <td>{{index+1}}</td>
         <td>{{ item['title'] }}</td>
      </tr>

      </tbody>
    </table>
    <center class="bg-white" style="border-radius: 1vw" v-else>
      موردی یافت نشد
    </center>

  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allItemsModalNama"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>نماگر ها    </p>
      <p @click="allItemsModalNama=!allItemsModalNama">❌</p>
    </div>
    <table v-if="allItemsListNama.length" class="table table-striped">
      <thead>
      <tr>
         <th>ردیف  </th>
         <th>نماگر  </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in allItemsListNama" :key="item.id">
        <td>{{index+1}}</td>
         <td>{{ item['measurement_chart'] }}</td>
      </tr>

      </tbody>
    </table>
    <center class="bg-white" style="border-radius: 1vw" v-else>
      موردی یافت نشد
    </center>

  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id_item)">تایید</button>
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import {useToast} from "vue-toastification";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
import cookies from "vue-cookies";

const toast = useToast();

export default {
  computed: {
    cookies() {
      return cookies
    }
  },
  components: {
    Reset,
    Sidebar,
    splash,
    vSelect
  },
  data() {
    return {
      allItems: [],
      ListExits: [],
      ListProcess: [],
      ListParents: [],
      selectExit: '',
      ListConsequences: [],
      selectConsequences: '',
      selectProcess: '',
      selectParent: '',
      axis: '',
      title: '',
      range: '',
      model: '',
      id_user: '',
      allListConsequencesModal: false,
      allNamaListConsequencesModal: false,
      ListConsequencesSelected: [],
      ListConsequencesNAMASelected: [],
      allItemsModal: false,
      allItemsModalNama: false,
      allItemsList: [],
      allItemsListNama: [],
      otherItems: [],
      id_item: '',
      deleteModal: false,
      is_update: false,
      status_show: false,
      status_loading: false,
      show_insert: false,
    }
  },
  methods: {
    setShow(){
      if (this.$cookies.isKey('type_2')){
        if (this.status_show===false){
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },
    acceptComplete(){
      if (this.status_loading){
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.allItem()
            }

          })
          .catch();
    },
    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
             if (response.message){
               toast.success(response.message)
               this.allItem()
               this.id_item = ''

             }
          })
          .catch();
    },
    editMethod(id){
      this.id_item = id
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(`${this.base_url}/Determining_Mission/edit/${id}`, requestOptions)
            .then(response => response.json())
            .then(response => {
              const item = response.item
              if (item){
                this.axis = item.axis
                this.title = item.title
                this.range = item.range
                this.model = item.model
              }
              if (item.definition_of_outputs){
                this.selectExit = item.definition_of_outputs

              }
              if (item.immediate_consequences){
                this.submitListConsequencesSelected()
              }
              if (item.consequences_for_determining_missions){


                  item.consequences_for_determining_missions.forEach((item)=>{
                    this.ListConsequencesSelected.push(item.consequences.id)
                    // this.allNamaListConsequencesModalMethod()

                  })

              }
              if (item.consequences_for_determining_missions_effects){
                  item.consequences_for_determining_missions_effects.forEach((item)=>{
                    this.ListConsequencesNAMASelected.push(item.consequences.id)
                  })
              }
              this.is_update = true
            })
            .catch();



    },
    deleteMethod(id){
      this.id_item = id
      this.deleteModal = true

    },
    allNamaListConsequencesModalMethod(){
      this.otherItems.length=0

      this.ListConsequencesSelected.forEach((item) => {
        // اینجا از تابع find استفاده می‌کنیم تا یک عنصر با شرط مناسب پیدا کنیم
        const foundConsequence = this.ListConsequences.find(consequence => parseInt(consequence.id) === parseInt(item));
        if (foundConsequence) {
          this.otherItems.push(foundConsequence)
        }
      });
      this.allNamaListConsequencesModal = true
    },
    showItems(id){
      this.allItemsList.length=0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all_items/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
           response.items.forEach((item)=>{
             this.allItemsList.push(item)
           })
            this.allItemsModal=true
          })
          .catch();
    },
    showItemsNama(id){
      this.allItemsListNama.length=0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all_items/effect/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
           response.items.forEach((item)=>{
             this.allItemsListNama.push(item)
           })
            this.allItemsModalNama=true
          })
          .catch();
    },
    submitListConsequencesSelected(){
      this.allListConsequencesModal=false
    },
    submitListConsequencesNamaSelected(){
      this.allNamaListConsequencesModal=false
    },
    allExits() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_of_output/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.items) {
              this.ListExits.length = 0
              response.items.forEach((item) => {
                this.ListExits.push(item)
              })
            }
          })
          .catch();
    },
    giveAllConsequences() {
      if (this.selectExit.id) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/Determining_Mission/select_consequences/${this.selectExit.id}`, requestOptions)
            .then(response => response.json())
            .then(response => {
              if (response.items) {
                this.ListConsequences.length = 0
                this.ListProcess.length = 0
                this.ListParents.length = 0
                this.selectConsequences = response.items[0]


                response.items.forEach((item) => {
                  this.ListConsequences.push(item)
                })

             if (response.process.length===1){
               response.process.forEach((item) => {
                 this.ListProcess.push(item)
               })
                this.selectProcess = response.process[0]
             }else{
               this.ListProcess.push(response.process)
               this.selectProcess = response.process
             }
            if (response.parent){
              response.parent.forEach((item) => {
                this.ListParents.push(item)
              })
                this.selectParent = response.parent[0]
            }


              }
            })
            .catch();
      }

    },
    resetModel(){
      this.selectConsequences=''
      this.selectProcess=''
      this.selectParent=''
      this.selectExit=''
      this.axis=''
      this.title=''
      this.range=''
      this.model=''
      this.ListConsequencesSelected.length=0
      this.ListConsequencesNAMASelected.length=0

    },
    resetItems(){
      this.resetModel()
      this.is_update=false
      this.id_item= ''
    },
    store() {
      if (this.axis.length===0){
        toast.error(' محور ماموریتی اجباری است!')
        return;
      }
      else if (this.title.length===0){
        toast.error('عنوان سند بالادستی اجباری است!')
        return;
      }

      else if (this.model.length===0){
        toast.error('مدل نقش آفرینی اجباری است!')
        return;
      }
      else if (this.selectConsequences.length===0){
        toast.error('خروجی اجباری است!')
        return;
      }
      else if (this.selectProcess.length===0){
        toast.error('پیامد اجباری است!')
        return;
      }



       var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('definition_of_outputs_id', this.selectExit.id)
      if (this.selectConsequences.type) {
        formdata.append('immediate_consequences_id', this.selectConsequences.id)
      }  if (!this.selectConsequences.type) {
        formdata.append('intermediate_outcomes_id', this.selectConsequences.id)
      }

      formdata.append('processes_id', this.selectProcess.id)
      if (this.selectParent && this.selectParent.id){

      formdata.append('sub_processes_id', this.selectParent.id)
      }
      formdata.append('axis', this.axis)
      formdata.append('title', this.title)
      formdata.append('range', this.range)
      formdata.append('model', this.model)
      formdata.append('consequences_for_determining_missions', JSON.stringify(this.ListConsequencesSelected))
      formdata.append('consequences_for_determining_missions_nama', JSON.stringify(this.ListConsequencesNAMASelected))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              return
            }
             toast.success('عملیات با موفقیت انجام شد!')
            this.resetModel()
            this.allItem()
          })
          .catch();
    },
    update(id) {

      if (this.axis.length===0){
        toast.error(' محور ماموریتی اجباری است!')
        return;
      }
      else if (this.title.length===0){
        toast.error('عنوان سند بالادستی اجباری است!')
        return;
      }

      else if (this.model.length===0){
        toast.error('مدل نقش آفرینی اجباری است!')
        return;
      }
      else if (this.selectConsequences.length===0){
        toast.error('خروجی اجباری است!')
        return;
      }
      else if (this.selectProcess.length===0){
        toast.error('پیامد اجباری است!')
        return;
      }



       var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('definition_of_outputs_id', this.selectExit.id)
      if (this.selectConsequences.type) {
        formdata.append('immediate_consequences_id', this.selectConsequences.id)
      }  if (!this.selectConsequences.type) {
        formdata.append('intermediate_outcomes_id', this.selectConsequences.id)
      }

      formdata.append('processes_id', this.selectProcess.id)
      if (this.selectParent && this.selectParent.id){

      formdata.append('sub_processes_id', this.selectParent.id)
      }
      formdata.append('axis', this.axis)
      formdata.append('title', this.title)
      formdata.append('range', this.range)
      formdata.append('model', this.model)
      formdata.append('consequences_for_determining_missions', JSON.stringify(this.ListConsequencesSelected))
      formdata.append('consequences_for_determining_missions_nama', JSON.stringify(this.ListConsequencesNAMASelected))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              return
            }
             toast.success('عملیات با موفقیت انجام شد!')
            this.resetModel()
            this.is_update=false
            this.id_item = ''
            this.allItem()
          })
          .catch();
    },
    allItem(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length=0
            response.all.forEach((item)=>{
              this.allItems.push(item)

            })
            this.setShow()
          })
          .catch();
    },
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
      }

    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
               if (this.is_mother){
              this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
  },

  mounted() {
    this.checkIsMother()
    this.allExits()
    this.allItem()
    this.fetchItems()
  },

  watch: {
    selectExit(newValue, oldValue) {
      this.giveAllConsequences()
    },
  }
}
</script>
<style scoped lang="scss">
label {
  font-size: 0.8vw;
}
</style>